import { type AggRequest, type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';

export type ConfluenceAuthorHydrationVariables = {
	pageIds: string[];
	blogPostIds: string[];
	includePages: boolean;
	includeBlogPosts: boolean;
};

export type ConfluenceHydratedAuthorUser = {
	accountId?: string | null;
	name?: string | null;
	picture?: string | null;
	accountStatus?: string | null;
};

type ConfluenceHydratedContent = {
	id: string;
	author?: {
		user?: ConfluenceHydratedAuthorUser | null;
	} | null;
};

export type ConfluenceAuthorHydrationData = {
	confluence?: {
		pages?: Array<ConfluenceHydratedContent | null> | null;
		blogPosts?: Array<ConfluenceHydratedContent | null> | null;
	} | null;
};

const OPERATION_NAME = 'SearchPageConfluenceAuthorHydration';

const getConfluenceAuthorHydrationQuery = () => `
query ${OPERATION_NAME}(
  $pageIds: [ID]!
  $blogPostIds: [ID]!
  $includePages: Boolean!
  $includeBlogPosts: Boolean!
) {
  confluence {
    pages(ids: $pageIds) @include(if: $includePages) {
      id
      author {
        user {
          accountId
          name
          picture
          accountStatus
        }
      }
    }
    blogPosts(ids: $blogPostIds) @include(if: $includeBlogPosts) {
      id
      author {
        user {
          accountId
          name
          picture
          accountStatus
        }
      }
    }
  }
}
`;

export type ConfluenceAuthorHydrationQueryProps = Pick<
	AggRequest<ConfluenceAuthorHydrationVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const fetchConfluenceAuthorHydrationQuery = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: ConfluenceAuthorHydrationQueryProps): Promise<AggResponse<ConfluenceAuthorHydrationData>> =>
	fetchAgg<ConfluenceAuthorHydrationVariables, ConfluenceAuthorHydrationData>({
		variables,
		aggAbsoluteUrl,
		graphQuery: getConfluenceAuthorHydrationQuery(),
		operationName: OPERATION_NAME,
		headers,
	});
